<template>
  <div class="printForm">
    <h2><Icon icon="print"></Icon>{{ _translate('print.title') }}</h2>
    <form class="printForm__container">
      <div class="printForm__panel printForm__sections">
        <h3>{{ _translate('print.printSections') }}</h3>
        <p>{{ _translate('print.printSectionsDetails') }}</p>
        <Checkbox id="useCover" :label="_translate('print.printCoverPage')" field="useCover" value="true" modal="true"></Checkbox>        
        <Checkbox id="useDisclaimer" :label="_translate('print.printDisclaimer')" field="useDisclaimer" value="true" modal="true"></Checkbox>        
        <Checkbox v-if="hasClient()" id="useProfile" :label="_translate('print.printClientProfile')" field="useProfile" value="true" modal="true"></Checkbox>
        <Checkbox v-if="hasClient()" id="useNetWorth" :label="_translate('print.printNetWorthReport')" field="useNetWorth" value="true" modal="true"></Checkbox>
        <Checkbox v-if="hasClient()" id="useRetirementPlanner" :label="_translate('print.printRetirementPlannerReport')" field="useRetirementPlanner" value="true" modal="true"></Checkbox>        
        <Checkbox v-if="hasClient()" id="useGPS" :label="_translate('print.printFinancialGpsReport')" field="useGPS" value="true" modal="true"></Checkbox>
        <Checkbox v-if="hasActiveTool()" id="useTool" :label="getActiveToolName()" field="useTool" value="true" modal="true"></Checkbox>
        <Checkbox id="useTool" :label="_translate('print.printGlobalDisclaimers')" field="useDisclaimers" value="true" modal="true"></Checkbox>                
      </div><!--
   --><div class="printForm__panel printForm__subsections">
        <h3>{{ _translate('print.printSubsections') }}</h3>
        <p>{{ _translate('print.printSubsectionsDetails') }}</p>

        <Dropdown id="lang" field="printLanguage" :label="_translate('print.reportLanguage')" proto="calc.language" context="modal"></Dropdown>

        <TextInput id="printTitleBox" :label="_translate('print.reportTitle')" :field="getTitleDefault()" context="modal" replace="name"></TextInput>

        <div v-if="sectionControls('useDisclaimer')">

          <Dropdown id="gender" field="printDisclaimer" :label="_translate('print.selectDisclaimer')" proto="calc.disclaimers" context="modal"></Dropdown>

        </div>

        <div v-if="sectionControls('useNetWorth') && hasClient()">

          <h4>{{ _translate('print.netWorthSections') }}</h4>

          <Checkbox id="useNetworthTotal" :label="_translate('print.includeNetWorthSummary')" field="useNetworthTotal" value="true" modal="true"></Checkbox>
          <Checkbox id="useNetworthComp" :label="_translate('print.includeAssetLiabilityComparison')" field="useNetworthComp" value="true" modal="true"></Checkbox>
          <Checkbox id="useNetworthBreakdown" :label="_translate('print.includeAssetsAccountsBreakdown')" field="useNetworthBreakdown" value="true" modal="true"></Checkbox>

        </div>

        <div v-if="sectionControls('useRetirementPlanner') && hasClient()">

          <h4>{{ _translate('print.retirementPlannerSection') }}</h4>
          <Checkbox id="useRetirementOutlook" :label="_translate('print.includeRetirementOutlook')" field="useRetirementOutlook" value="true" modal="true"></Checkbox>
          <Checkbox id="useRetirementIncome" :label="_translate('print.includeRetirementIncomeRequired')" field="useRetirementIncome" value="true" modal="true"></Checkbox>
          <Checkbox id="useRetirementBenefits" :label="_translate('print.includeGovernmentBenefits')" field="useRetirementBenefits" value="true" modal="true"></Checkbox>
          <Checkbox id="useRetirementPension" :label="_translate('print.includePension')" field="useRetirementPension" value="true" modal="true"></Checkbox>
          <Checkbox id="useRetirementValues" :label="_translate('print.includeAssetValues')" field="useRetirementValues" value="true" modal="true"></Checkbox>

          <Checkbox v-if="tableHasData('wealthAccumulationData')" id="useRetirementWealthAccumulation" :label="_translate('print.includeWealthAccumulation')" field="useRetirementWealthAccumulation" value="true" modal="true"></Checkbox>
          <Checkbox v-if="tableHasData('wealthAccumulationData') && sectionControls('useRetirementWealthAccumulation')" id="useRetirementWealthAccumulationGraph" :label="_translate('print.includeChart')" field="useRetirementWealthAccumulationGraph" value="true" modal="true" indent="true"></Checkbox>
          <Checkbox v-if="tableHasData('wealthAccumulationData') && sectionControls('useRetirementWealthAccumulation')" id="useRetirementWealthAccumulationTable" :label="_translate('print.includeTable')" field="useRetirementWealthAccumulationTable" value="true" modal="true" indent="true"></Checkbox>

          <Checkbox v-if="tableHasData('systematicWithdrawalsData')" id="useRetirementDeacumulation" :label="_translate('print.includeWealthDeaccumulation')" field="useRetirementDeacumulation" value="true" modal="true"></Checkbox>
          <Checkbox v-if="tableHasData('systematicWithdrawalsData') && sectionControls('useRetirementDeacumulation')" id="useRetirementDeacumulationGraph" :label="_translate('print.includeChart')" field="useRetirementDeacumulationGraph" value="true" modal="true" indent="true"></Checkbox>
          <Checkbox v-if="tableHasData('systematicWithdrawalsData') && sectionControls('useRetirementDeacumulation')" id="useRetirementDeacumulationTable" :label="_translate('print.includeTable')" field="useRetirementDeacumulationTable" value="true" modal="true" indent="true"></Checkbox>

          <Checkbox v-if="tableHasData('postRetirementCashFlowData')" id="useRetirementCashflows" :label="_translate('print.includePostRetirementCashFlows')" field="useRetirementCashflows" value="true" modal="true"></Checkbox>
          <Checkbox v-if="tableHasData('postRetirementCashFlowData') && sectionControls('useRetirementCashflows')" id="useRetirementCashflowsGraph" :label="_translate('print.includeChart')" field="useRetirementCashflowsGraph" value="true" modal="true" indent="true"></Checkbox>
          <Checkbox v-if="tableHasData('postRetirementCashFlowData') && sectionControls('useRetirementCashflows')" id="useRetirementCashflowsTable" :label="_translate('print.includeTable')" field="useRetirementCashflowsTable" value="true" modal="true" indent="true"></Checkbox>

        </div>

        <div v-if="sectionControls('useGPS') && hasClient()">

          <h4>{{ _translate('print.financialGpsSection') }}</h4>
          <Checkbox id="useGPSOverview" :label="_translate('print.includeGpsDetails')" field="useGPSOverview" value="true" modal="true"></Checkbox>
          <Checkbox id="useGPSProjections" :label="_translate('print.includeGpsProjections')" field="useGPSProjections" value="true" modal="true"></Checkbox>
          <Checkbox id="useGPSShock" :label="_translate('print.includeGpsResilience')" field="useGPSShock" value="true" modal="true"></Checkbox>

        </div>

        <div v-if="sectionControls('useDisclaimers')">

          <h4>{{ _translate('print.disclaimerSection') }}</h4>
          <Checkbox id="useDisclaimersGlobal" :label="_translate('print.includeGlobalDisclaimer')" field="useDisclaimersGlobal" value="true" modal="true"></Checkbox>

        </div>

        <div v-if="sectionControls('useTool')">

          <h4>Tool Sections</h4>
          <Checkbox id="useToolChart" label="Include Tool Chart" field="useToolChart" value="true" modal="true"></Checkbox>
          <Checkbox id="useToolTable" label="Include Tool Summary Table" field="useToolTable" value="true" modal="true"></Checkbox>

        </div>

      </div>

    </form>
      <div class="printForm__control">
        <button class="button" @click="doPrint">{{ _translate('print.button') }}</button>
      </div>      
  </div>
</template>

<script>

import Checkbox from '../Checkbox.vue'
import Dropdown from '../Dropdown.vue'
import Icon from '../Icon.vue'
import TextInput from '../TextInput.vue'

export default {


  components: {

    Checkbox,
    Dropdown,
    Icon,
    TextInput,

  }, 
  
  computed: {

  },

  methods: {


    /**
     * METHOD: doPrint()
     * @param  {Event} e - the event that triggered the function.
     * 
     * This method is triggered when the user actually clicks the print button within the print modal
     * component. It is designed to: 
     * 
     *  a) compile all of the user's input options into a single collection of settings
     *  b) pass that collection of settings into the reportModel function to generate the object needed
     *     for the PDFMake.js library
     *  c) pass the object into PDFMake.js, where the custom PDF is generated, based on the
     *  supplied object.
     */
    doPrint(e) {

      // Prevent default
      e.preventDefault();

      // Use the component's own internal method to generate the arguments that will be passed
      // to the reportModel function (loaded in the main.js trunk).
      var args = this.getPDFObject(),

      // Now we pass the arguments to the reportModel function in order to generate the model we need for 
      // our specific implementation of the report.
      model = window.reportModel(args);

      // Finally, pass the reportModel object directly into the PDFMake.js library, and trigger
      // the library's open() method to force the generated PDF to open in a new window.
      window.pdfMake.createPdf(model).open()

    },


    /**
     * METHOD: hasActiveTool()
     * @return {Boolean} - returns true if the application currently has a tool actively open
     *
     * This method is used to check if the application currently has on of the tools active (open).
     * The purpose of this check is to determine whether or not to provide the user with the
     * option of including the tool's output in the PDF.
     */
    hasActiveTool() {

      var tool = this.$store.getters.getCurrentTool;

      if ( tool === false || tool === undefined ) {

        return false;

      }

      return true;

    },


    /**
     * METHOD: hasClient()
     * @return {Boolean} - returns true if client data has been loaded into the application.
     *
     * This method is used to check if the application has active client data. The purpose of this 
     * check is to determine what parts of the print form should be displayed. Ordinarily, the 
     * print form does not become available until the user has loaded a client. The only exception
     * to this rule is if the client chooses to activate a tool before loading client data. In this
     * case, client-based sections of the PDF should not be available for inclusion.
     */
    hasClient() {

      return this.$store.getters.hasClient();

    },


    /**
     * METHOD: getActiveToolName()
     * @return {String} - returns the name of the current tool for display in the print modal.
     *
     * This method simply checks the current tool and returns the appropriate name for 
     * display within the tool selection checkbox. 
     */
    getActiveToolName() {

      var tool = this.$store.getters.getCurrentTool,
          toolName = 'Current Tool';

      switch ( tool ) {

        case 'savingsFuture': 
           toolName = 'Savings Required for Future';
           break;

        case 'investmentFuture': 
           toolName = 'Future Value of an Investment';
           break;

        case 'regularWithdrawals': 
           toolName = 'Regular Withdrawals from an Investment';
           break;

        case 'systematicWithdrawals':
          toolName = 'Systematic Withdrawals from an Investment';
          break;         

      }

      var val = this._translate('print.printTool');
      return val.replace('%s', toolName);

    },


    /**
     * METHOD: sectionControls()
     * @param  {String} section - a value indicating the section to check
     * @return {Boolean} - returns true if the section should be made available in the print modal
     *
     * This method is intended as means of identifying whether or not a particular section
     * should be made available (rendered) within the print modal.
     */
    sectionControls(section) { 

      if ( section === 'useTool' ) {

        return (this.$store.getters.getCurrentTool) ? true : false;

      }

      var args = this.$store.getters.getPrintOptions;

      if ( args[section] !== undefined ) {

        return args[section];

      }

      return false;

    },


    /**
     * METHOD: tableHasData()
     * @param  {String} table - an identifier 
     * @return {Boolean} - returns whether or not the requested table contains any data.
     *
     * This method is intended to check whether or not the requested table has any data. It simply
     * checks to determine if the table array has a length greater than 0 and returns the 
     * result of that comparison.
     */
    tableHasData(table) {

      return window.tables[table].length > 0;

    },


    /**
     * METHOD: getPDFObject()
     * @return {Object} - returns the compiled PDF data.
     *
     * This method is used to create the object that is passed into the reportModel function
     * in order to create the data that is passed to the PDFMake script. 
     *
     * The method starts by pulling in the print object from the application's primary store.
     * It then does several checks and applies additional information to the object, based
     * on the results of those checks.
     */
    getPDFObject() {

      var args = window.rawObject(this.$store.getters.getPrintOptions);

      if ( ! this.hasClient() ) {

        args.useProfile  = false;
        args.useNetWorth = false;
        args.useRetirementPlanner = false;
        args.useGPS = false;

      }

      if ( args.printLanguage === 'default' ) {
        args.printLanguage = this.$store.getters.getCurrentLanguage;
      }

      if ( window.tables.legends.netWorth === undefined ) {

        args.useNetWorth = false;

      }

      /**
       * Get the client details.
       * The getArgDetals() function will actually compile all of the client's actual
       * details into the args.details object.
       */
      args.details = this.getArgDetails(args);

      if ( this.$store.getters.getCurrentTool === false ) {

        args.useTool = false;

      }

      if ( args.useCover ) {

        args.firstPage = false;

      }

      else { 

        args.firstPage = true;

      }

      return args;

    },


    /**
     * METHOD: getReportName()
     * @return {String} - returns the name of the report, as defined in the print modal.
     *
     * This method simply gets the value of the print title box. If the value is not empty, it returns
     * the value. If it IS empty, it instead gets the default value defined in the application
     * constant and returns that instead.
     */
    getReportName() {

      var report_name = document.getElementById('printTitleBox').value;

      if ( report_name !== '' ) {

        return report_name;

      } 

      var c = this.$store.getters.getConstants();
          report_name = c.printTitle

      return report_name.replace('%n', this.$store.getters.getCurrentClientName());

    },


    /**
     * METHOD: getSpouseName()
     * @return {String} - returns the spouse name
     *
     * This method gets the name of the active client's spouse and returns it.
     */
    getSpouseName() {

      var name = this.$store.getters.getClientSpouseName(),
          string = '';

      if ( name ) {

        string += name.firstName.trim();
        string += ' ';
        string += name.lastName.trim();

      }

      return string.trim();

    },


    /**
     * METHOD: getDisclaimer()
     * @return {String} - returns the disclaimer selected in the print modal.
     *
     * This method simply gets the text of the disclaimer selected in the print modal. This
     * value is set in the Settings > Print Options > Disclaimers repeater.
     */
    getDisclaimer() {

      var lang = this.$store.getters.getCurrentLanguage,
          index = (lang === 'fr') ? 'textFr' : 'text';

      return this.$store.getters.disclaimersValue(index);

    },


    /**
     * METHOD: getArgDetails()
     * @param  {Object} args - arguments passed from the getPDFObject function()
     * @return {Object} - returns and object containing all of the key information to be passed into the reportModel
     *
     * This method compiles client data together into a single object for use in the reportModel. 
     * It uses the args object passed to it to determine whether or not populate certain key data points.
     */
    getArgDetails(args) {

      var ob = {},
          employerAddress = this.$store.getters.getAddressObject({field: 'details.employerAddress'});

      ob.reportName = this.getReportName();
      ob.clientName = this.$store.getters.getCurrentClientName();
      ob.clientAddress = ( ! this.hasClient() ) ? '' : this.$store.getters.getAddressObject({field: 'details.address'});

      ob.disclaimer = this.getDisclaimer();

      ob.clientDetails = ( ! this.hasClient() ) ? {} : {

          gender: this.getTranslatedDropdownValue('dropdown.gender', 'details.gender'), //this._translate('dropdown.gender.' + this.$store.getters.getFieldData({field: 'details.gender'})),
          birthdate: this.getClientDOBText(),
          maritalStatus: this.getTranslatedDropdownValue('dropdown.maritalStatus','details.maritalStatus'), //_translate('dropdown.maritalStatus.' + this.$store.getters.getFieldData({field: 'details.maritalStatus'})),
          spouse: this.getSpouseName(),
          phoneHome: this.$store.getters.getFieldData({field: 'details.phoneHome'}),
          phoneWork: this.$store.getters.getFieldData({field: 'details.phoneWork'}),
          phoneCell: this.$store.getters.getFieldData({field: 'details.phoneCell'}),
          fax: this.$store.getters.getFieldData({field: 'details.fax'}),
          email: this.$store.getters.getFieldData({field: 'details.email'}),
          occupation: this.$store.getters.getFieldData({field: 'details.occupation'}),
          employer: this.$store.getters.getFieldData({field: 'details.employer'}),
          employerAddress: (employerAddress.length > 0) ? employerAddress : '',

          beneficiaryName: this.beneficaryName(),
          beneficiaryAge: this.$store.getters.getFieldData({field: 'details.beneficiaryAge'}),

          executorName: this.executorName(),
          executorAge: this.$store.getters.getFieldData({field: 'details.executorAge'}),

      },

      // DATA FOR THE NET WORTH REPORT
        
      ob.netWorth = ( ! args.useNetWorth ) ? {} : this.getNetWorthData();

      // DATA FOR THE RETIREMENT PLANNER REPORT
        
      ob.retirementPlanner = ( ! args.useRetirementPlanner ) ? {} : this.getRetirementPlannerData();

      // DATA FOR THE FINANCIAL GPS
        
      ob.financialGPS = ( ! args.useGPS ) ? {} : this.getFinancialGPSData();

      ob.tool = this.getToolData();

      ob.disclaimers = ( ! args.useDisclaimers ) ? [] : this.$store.getters.getGlobalDisclaimers.disclaimers;

      console.log('PRINT DATA');
      console.log(ob);
      return ob;

    },


    /**
     * METHOD: getTranslatedDropdownValue()
     * @param  {String} key   the translation key partial
     * @param  {String} field the dropdown field
     * @return {String} - the translated value of the dropdown
     *
     * This method basically checks to see if the dropdown value is null. If it is not null
     * it then takes the partial key, concatenates it with the value of the field and
     * uses that value to request the translation string from the translation object.
     */
    getTranslatedDropdownValue(key, field) {
      
      var val = this.$store.getters.getFieldData({field: field});

      return (val) ? this._translate(key + '.' + val) : '--';

    },


    /**
     * METHOD: getClientDOBText()
     * @return {String} - The date of birth string
     *
     * This method basically gets the string of the date of birth. It uses
     * the same basic logic as the version in the store, but is used here
     * so that it can tap into the _translation function.
     */
    getClientDOBText() {
      var dob = this.$store.getters.getFieldData({field: 'details.dateOfBirth'}),
          months = this.$store.getters.getPrototype('dropdown','months'),
          dob_string = this._translate("dropdown.months." + months[Number(dob.month)]) + ' ' + dob.day + ', ' + dob.year;

      return dob_string;      
    },


    /**
     * METHOD: beneficaryName()
     * @return {String} - returns the full name of the designated beneficiary.
     *
     * This method gets the full name of the designated beneficiary.
     */
    beneficaryName() {
          
      var first_name = this.$store.getters.getFieldData({field: 'details.beneficiaryFirstName'}),
          last_name = this.$store.getters.getFieldData({field: 'details.beneficiaryLastName'});

      var name = first_name + ' ' + last_name;

      return name.trim();

    },


    /**
     * METHOD: executorName()
     * @return {String} - returns the full name of the designated executor.
     *
     * This method gets the full name of the designated executor.
     */
    executorName() {
          
      var first_name = this.$store.getters.getFieldData({field: 'details.executorFirstName'}),
          last_name = this.$store.getters.getFieldData({field: 'details.executorLastName'});

      var name = first_name + ' ' + last_name;

      return name.trim();

    },


    /**
     * METHOD: getNetWorthData()
     * @return {Object} - returns the data for Net Worth section of the PDF Report.
     *
     * This method generates the object required for the Net Worth portion of the PDF report.
     * It uses additional sub methods to generate:
     *  - totals
     *  - assets
     *  - liabilities 
     */
    getNetWorthData() {

      var obj = false;

      if ( true ) {

        obj = {

          charts: {

            netWorth: 'netWorthPDF',
            assets: 'netWorthAssetsPDF',
            liabilities: 'netWorthLiabilitiesPDF',

          },

          totals: this.getNetWorthTotals(),

          assets: this.getNetWorthPartialValues('assets'),

          liabilities: this.getNetWorthPartialValues('liabilities'),      

        }

      }

      return obj;

    },

    getNetWorthTotals() {
      
      var obj = {};

      if ( window.tables.legends.netWorth !== undefined ) {

        for ( var x = 0; x < window.tables.legends.netWorth.length; x++ ) {

          obj[window.tables.legends.netWorth[x].slug] = {

            value: this.getNetWorthTotal(window.tables.legends.netWorth[x].slug),
            color: window.tables.legends.netWorth[x].color

          };

      }

      }

      return obj; 

    },

    getNetWorthTotal(section) {

      if ( section === 'netWorth' ) {

        return window.formatCurrency(window.tables.netWorth.total);

      }

      else {

        var total = 0;

        for ( var x in window.tables.netWorth[section] ) {

          for ( var y in window.tables.netWorth[section][x] ) {

            total += Number(window.tables.netWorth[section][x][y].total);

          }

        }

        return window.formatCurrency(total);

      }

    },

    getNetWorthPartialValues(type = 'assets') {

      var obj = {};

      if ( type === 'assets' && window.tables.legends.netWorthAssets !== undefined) {

        for ( var x = 0; x < window.tables.legends.netWorthAssets.length; x++ ) {

          if ( window.tables.legends.netWorthAssets[x].slug === 'open_chequing' ||
               window.tables.legends.netWorthAssets[x].slug === 'open_savings' ) {

            if ( obj.liquid === undefined ) { obj.liquid = {}; }

            var split = window.tables.legends.netWorthAssets[x].slug.split('_');
            obj.liquid[split[1]] = {
              value: this.formatNetWorthReportLine(
                window.tables.netWorth.assets.liquid[window.tables.legends.netWorthAssets[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.assetsBreakdown.liquid[window.tables.legends.netWorthAssets[x].slug], 'balance'
              ),
              color: window.tables.legends.netWorthAssets[x].color,
            }

          }

          else if ( window.tables.legends.netWorthAssets[x].slug === 'registered_tfsa' ||
                    window.tables.legends.netWorthAssets[x].slug === 'open_bonds' ||
                    window.tables.legends.netWorthAssets[x].slug === 'open_stocks' ||
                    window.tables.legends.netWorthAssets[x].slug === 'open_mutualFunds' ||
                    window.tables.legends.netWorthAssets[x].slug === 'open_gics' ||
                    window.tables.legends.netWorthAssets[x].slug === 'open_other' ) {

            if ( obj.semiLiquid === undefined ) { obj.semiLiquid = {}; }

            var split = window.tables.legends.netWorthAssets[x].slug.split('_');
            if ( split )
            obj.semiLiquid[split[1]] = {
              value: this.formatNetWorthReportLine(
                window.tables.netWorth.assets.semiliquid[window.tables.legends.netWorthAssets[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.assetsBreakdown.semiliquid[window.tables.legends.netWorthAssets[x].slug], 'balance'
              ),
              color: window.tables.legends.netWorthAssets[x].color,
            }

          }

          else if ( window.tables.legends.netWorthAssets[x].slug === 'registered_savings' ||
                    window.tables.legends.netWorthAssets[x].slug === 'registered_stocks' ||
                    window.tables.legends.netWorthAssets[x].slug === 'registered_mutualFunds' ||
                    window.tables.legends.netWorthAssets[x].slug === 'registered_gics' ||
                    window.tables.legends.netWorthAssets[x].slug === 'registered_rrif' ||
                    window.tables.legends.netWorthAssets[x].slug === 'registered_other' ||
                    window.tables.legends.netWorthAssets[x].slug === 'registered_dpspEsopGrsp' ||
                    window.tables.legends.netWorthAssets[x].slug === 'lockedin_employerPension' ||
                    window.tables.legends.netWorthAssets[x].slug === 'lockedin_lockedRrsp' ) {

            if ( obj.rrsp === undefined ) { obj.rrsp = {}; }

            var split = window.tables.legends.netWorthAssets[x].slug.split('_');
            if (split[1] === 'mutualFunds' ) { split[1] += 'R' }
            obj.rrsp[split[1]] = {
              value: this.formatNetWorthReportLine(
                window.tables.netWorth.assets.retirement[window.tables.legends.netWorthAssets[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.assetsBreakdown.retirement[window.tables.legends.netWorthAssets[x].slug], 'balance'
              ),
              color: window.tables.legends.netWorthAssets[x].color,
            }

          }

          else if ( window.tables.legends.netWorthAssets[x].slug === 'realestate_home' ||
                    window.tables.legends.netWorthAssets[x].slug === 'realestate_other' ) {

            if ( obj.other === undefined ) { obj.other = {}; }

            var split = window.tables.legends.netWorthAssets[x].slug.split('_');
            split[1] = split[1].charAt(0).toUpperCase() + split[1].slice(1);

            obj.other['realEstate' + split[1]] = {
              value: this.formatNetWorthReportLine(
                window.tables.netWorth.assets.realestate[window.tables.legends.netWorthAssets[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.assetsBreakdown.realestate[window.tables.legends.netWorthAssets[x].slug], 'value'
              ),
              color: window.tables.legends.netWorthAssets[x].color,
            }

          }

          else if ( window.tables.legends.netWorthAssets[x].slug === 'property_other' ) {

            if ( obj.other === undefined ) { obj.other = {}; }

            obj.other['personalProperty'] = {
              value: this.formatNetWorthReportLine(
                window.tables.netWorth.assets.property[window.tables.legends.netWorthAssets[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.assetsBreakdown.property[window.tables.legends.netWorthAssets[x].slug], 'value'
              ),
              color: window.tables.legends.netWorthAssets[x].color,
            }

          }

          else if ( window.tables.legends.netWorthAssets[x].slug === 'business_interests' ) {

            if ( obj.other === undefined ) { obj.other = {}; }

            obj.other['businessInterest'] = {
              value: this.formatNetWorthReportLine(
                window.tables.netWorth.assets.business[window.tables.legends.netWorthAssets[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.assetsBreakdown.business[window.tables.legends.netWorthAssets[x].slug], 'value'
              ), 
              color: window.tables.legends.netWorthAssets[x].color,
            }

          }        

          else if ( window.tables.legends.netWorthAssets[x].slug === 'other_taxDefered' ) {

            if ( obj.other === undefined ) { obj.other = {}; }

            obj.other['taxDefered'] = {
              value: this.formatNetWorthReportLine(
                window.tables.netWorth.assets.other[window.tables.legends.netWorthAssets[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.assetsBreakdown.other[window.tables.legends.netWorthAssets[x].slug], 'value'
              ),
              color: window.tables.legends.netWorthAssets[x].color,
            }

          } 

        }

      }

      else if ( type === 'liabilities' && window.tables.legends.netWorthLiabilities !== undefined ) {

        for ( var x = 0; x < window.tables.legends.netWorthLiabilities.length; x++ ) {

          if ( window.tables.legends.netWorthLiabilities[x].slug === 'debt_carLoans' ||
               window.tables.legends.netWorthLiabilities[x].slug === 'debt_creditCards' ||
               window.tables.legends.netWorthLiabilities[x].slug === 'debt_lineOfCredit' ||
               window.tables.legends.netWorthLiabilities[x].slug === 'debt_other' ) {

            if ( obj.shortTerm === undefined ) { obj.shortTerm = {}; }

            var split = window.tables.legends.netWorthLiabilities[x].slug.split('_');

            if ( window.tables.legends.netWorthLiabilities[x].slug === 'debt_other' ) {

              split[1] = 'otherLiabilities';

            }

            obj.shortTerm[split[1]] = {
              value: '-' + this.formatNetWorthReportLine(
                window.tables.netWorth.liabilities.shortterm[window.tables.legends.netWorthLiabilities[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.liabilitiesBreakdown.shortterm[window.tables.legends.netWorthLiabilities[x].slug], 'balance', true
              ),
              color: window.tables.legends.netWorthLiabilities[x].color,
            }

          }

          else if ( window.tables.legends.netWorthLiabilities[x].slug === 'debt_mortgageHome' ||
                    window.tables.legends.netWorthLiabilities[x].slug === 'debt_mortgageOther' ||
                    window.tables.legends.netWorthLiabilities[x].slug === 'debt_investmentLoans' ) {

            if ( obj.longTerm === undefined ) { obj.longTerm = {}; }

            var split = window.tables.legends.netWorthLiabilities[x].slug.split('_');
            
            obj.longTerm[split[1]] = {
              value: '-' + this.formatNetWorthReportLine(
                window.tables.netWorth.liabilities.longterm[window.tables.legends.netWorthLiabilities[x].slug]
              ),
              accounts: this.formatNetWorthReportAccount(
                window.tables.netWorth.liabilitiesBreakdown.longterm[window.tables.legends.netWorthLiabilities[x].slug], 'balance', true
              ),
              color: window.tables.legends.netWorthLiabilities[x].color,
            }

          }          

        }

      }

      console.log(obj);
      return [obj];

    },

    formatNetWorthReportLine(line) {

      var output = '';

      output = window.formatCurrency(line.client);

      if ( line.spouse > 0 ) {

        var spouse_name = this.$store.getters.getClientSpouseName();
        output += '\n(' + spouse_name.firstName + ') ' + window.formatCurrency(line.spouse);

      }

      return output;

    },

    formatNetWorthReportAccount(rawData, value, negative = false) {

      var accounts = window.rawObject(rawData);

      for ( var x in accounts ) {

        if ( accounts[x][value].trim() !== '' && accounts[x][value] !== undefined ) {

          accounts[x].display = window.formatCurrency(Number(accounts[x][value]));
          if ( negative ) { accounts[x].display = '-' + accounts[x].display; }
          if ( accounts[x].spouse > 0 ) {

            var spouse_name = this.$store.getters.getClientSpouseName();
            accounts[x].display = '(' + spouse_name.firstName + ') ' + accounts[x].display;

          } 

        } 

      }

      return accounts;

    },

    getTitleDefault() {

      var lang = this.$store.getters.getCurrentLanguage,
          print = this.$store.getters.getPrintOptions;

      if (print.printLanguage !== 'default') {
        lang = print.printLanguage;
      }

      return (lang === 'fr') ? 'printTitleFr' : 'printTitle';

    },

    getRetirementPlannerData() {

      var obj = false;

      if ( true ) {

        obj = {};

        var details = window.tables.retirementSummary;

        if ( this.sectionControls('useRetirementOutlook') ) {

          obj.outlook = details.outlook;

        }

        if ( this.sectionControls('useRetirementIncome') ) {

          obj.retirement = details.retirement;

        }

        if ( this.sectionControls('useRetirementBenefits') ) {

          obj.government = details.government;

        }

        if ( this.sectionControls('useRetirementPension') ) {

          obj.pension = details.pension;

        }

        if ( this.sectionControls('useRetirementValues') ) {

          obj.investments = details.investments;

        }

        if ( this.useWealthAccumulationSection() ) {

          obj.wealthAccumulation = this.getWealthAccumulationData();

        }

        if ( this.useDeaccumulationSection() ) {

          obj.wealthDeaccumulation = this.getDeaccumulationData();

        }

        if ( this.usePostRetirementCashflowSection() ) {

          obj.retirementCashFlows = this.getPostRetirementCashflowData();

        }


      }

      return obj;

    },

    useWealthAccumulationSection() {

      if ( window.tables.wealthAccumulationData.length === 0 ) {

        return false;

      }

      var args = this.$store.getters.getPrintOptions;

      return args.useRetirementWealthAccumulation;

    },

    getWealthAccumulationData() {

      var obj = false,
          widths = {
            savings: '*',
            lockedin: '*',
            registered: '*',
            tfsa: '*',
          };

      if ( true ) {

        obj = {};
        obj.chart = 'wealthAccumulationChartPDF';

        obj.fields = [

            {
              field: 'age',
              name: 'pdf.age',
              width: 40,
            },

        ];

        var x = 1;

        for ( var k in widths ) {

          if ( window.tables.legends.wealthAccumulationChart !== undefined ) {

            for ( var y = 0; y < window.tables.legends.wealthAccumulationChart.length; y++ ) {

              if ( window.tables.legends.wealthAccumulationChart[y].slug === k ) {

                obj.fields[x] = {
                  field: k,
                  name: window.tables.legends.wealthAccumulationChart[y].name,
                  color: window.tables.legends.wealthAccumulationChart[y].color,
                  width: widths[k], 
                };

                x += 1;

              }

            }

          }

        };

        obj.values = [];

        for ( var x = 0; x < window.tables.wealthAccumulationData.length; x++ ) {

          obj.values[x] = {
            age: window.tables.wealthAccumulationData[x].age,
          }

          if ( window.tables.wealthAccumulationData[x].open !== undefined) {
            obj.values[x].savings = window.formatCurrency(window.tables.wealthAccumulationData[x].open);
          }          

          if ( window.tables.wealthAccumulationData[x].rrsp !== undefined) {
            obj.values[x].registered = window.formatCurrency(window.tables.wealthAccumulationData[x].rrsp);
          }          

          if ( window.tables.wealthAccumulationData[x].tfsa !== undefined) {
            obj.values[x].tfsa = window.formatCurrency(window.tables.wealthAccumulationData[x].tfsa);
          }          

          if ( window.tables.wealthAccumulationData[x].lockedin !== undefined) {
            obj.values[x].lockedin = window.formatCurrency(window.tables.wealthAccumulationData[x].lockedin);
          }          

        }

      }

      return obj;

    },

    useDeaccumulationSection() {

      if ( window.tables.systematicWithdrawalsData.length === 0 ) {

        return false;

      }

      var args = this.$store.getters.getPrintOptions;

      return args.useRetirementDeacumulation;

    },    

    getDeaccumulationData() {

      var obj = false,
          widths = {
            savings: '*',
            lockedin: '*',
            rrsp: '*',
            tfsa: '*',
          };

      if ( true ) {

        obj = {};
        obj.chart = 'systematicWithdrawalsChartPDF';

        obj.fields = [

            {
              field: 'age',
              name: 'pdf.age',
              width: 40,
            },

            {
              field: 'year',
              name: 'retirementPlanner.year',
              width: 40,
            },            

        ];

        var x = 1;

        for ( var k in widths ) {

          if ( window.tables.legends.systematicWithdrawalsChart !== undefined ) {

            for ( var y = 0; y < window.tables.legends.systematicWithdrawalsChart.length; y++ ) {

              if ( window.tables.legends.systematicWithdrawalsChart[y].slug === k ) {

                obj.fields[x] = {
                  field: k,
                  name: window.tables.legends.systematicWithdrawalsChart[y].name,
                  color: window.tables.legends.systematicWithdrawalsChart[y].color,
                  width: widths[k], 
                };

                x += 1;

              }

            }

          }

        };

        obj.values = [];

        for ( var x = 0; x < window.tables.systematicWithdrawalsData.length; x++ ) {

          obj.values[x] = {
            age: window.tables.systematicWithdrawalsData[x].age,
            year: window.tables.systematicWithdrawalsData[x].year + '',
          }

          if ( window.tables.systematicWithdrawalsData[x].savings !== undefined) {
            obj.values[x].savings = window.formatCurrency(window.tables.systematicWithdrawalsData[x].savings);
          }          

          if ( window.tables.systematicWithdrawalsData[x].rrsp !== undefined) {
            obj.values[x].rrsp = window.formatCurrency(window.tables.systematicWithdrawalsData[x].rrsp);
          }          

          if ( window.tables.systematicWithdrawalsData[x].tfsa !== undefined) {
            obj.values[x].tfsa = window.formatCurrency(window.tables.systematicWithdrawalsData[x].tfsa);
          }          

          if ( window.tables.systematicWithdrawalsData[x].lockedin !== undefined) {
            obj.values[x].lockedin = window.formatCurrency(window.tables.systematicWithdrawalsData[x].lockedin);
          }          

        }

      }

      return obj;

    },

    usePostRetirementCashflowSection() {

      if ( window.tables.systematicWithdrawalsData.length === 0 ) {

        return false;

      }

      var args = this.$store.getters.getPrintOptions;

      return args.useRetirementCashflows;

    },

    getPostRetirementCashflowData() {

      var obj = false,
          widths = {
            cpp: '*',
            oas: '*',
            pension: '*',
            savings: '*',
            lockedin: '*',
            rrsp: '*',
            tfsa: '*',
            other: '*',
          };

      if ( true ) {

        obj = {};
        obj.chart = 'postRetirementCashFlowChartPDF';

        obj.fields = [

            {
              field: 'age',
              name: 'pdf.age',
              width: 30,
            },

            {
              field: 'year',
              name: 'retirementPlanner.year',
              width: 30,
            },

            {
              field: 'income',
              name: 'retirementPlanner.income',
              width: '*'
            }           

        ];

        var x = 3;

        for ( var k in widths ) {

          if ( window.tables.legends.postRetirementCashFlowChart !== undefined ) {

            for ( var y = 0; y < window.tables.legends.postRetirementCashFlowChart.length; y++ ) {

              if ( window.tables.legends.postRetirementCashFlowChart[y].slug === k ) {

                obj.fields[x] = {
                  field: k,
                  name: window.tables.legends.postRetirementCashFlowChart[y].name,
                  color: window.tables.legends.postRetirementCashFlowChart[y].color,
                  width: widths[k], 
                };

                x += 1;

              }

            }

          }

        };

        obj.values = [];

        for ( var x = 0; x < window.tables.postRetirementCashFlowData.length; x++ ) {

          obj.values[x] = {
            age: window.tables.postRetirementCashFlowData[x].age,
            year: window.tables.postRetirementCashFlowData[x].year,
            income: window.formatCurrency(window.tables.postRetirementCashFlowData[x].available),
          }

          if ( window.tables.postRetirementCashFlowData[x].cpp !== undefined) {
            obj.values[x].cpp = window.formatCurrency(window.tables.postRetirementCashFlowData[x].cpp);
          }

          if ( window.tables.postRetirementCashFlowData[x].oas !== undefined) {
            obj.values[x].oas = window.formatCurrency(window.tables.postRetirementCashFlowData[x].oas);
          }

          if ( window.tables.postRetirementCashFlowData[x].pension !== undefined) {
            obj.values[x].pension = window.formatCurrency(window.tables.postRetirementCashFlowData[x].pension);
          }

          if ( window.tables.postRetirementCashFlowData[x].savings !== undefined) {
            obj.values[x].savings = window.formatCurrency(window.tables.postRetirementCashFlowData[x].savings);
          }

          if ( window.tables.postRetirementCashFlowData[x].rrsp !== undefined) {
            obj.values[x].rrsp = window.formatCurrency(window.tables.postRetirementCashFlowData[x].rrsp);
          }

          if ( window.tables.postRetirementCashFlowData[x].tfsa !== undefined) {
            obj.values[x].tfsa = window.formatCurrency(window.tables.postRetirementCashFlowData[x].tfsa);
          }

          if ( window.tables.postRetirementCashFlowData[x].lockedin !== undefined) {
            obj.values[x].lockedin = window.formatCurrency(window.tables.postRetirementCashFlowData[x].lockedin);
          }

          if ( window.tables.postRetirementCashFlowData[x].other !== undefined) {
            obj.values[x].other = window.formatCurrency(window.tables.postRetirementCashFlowData[x].other);
          }

        }

      }

      return obj
    },

    getFinancialGPSData() {

      return window.tables.financialGPSSummary;

    },

    getToolData() {

      var obj = {},
          tool = this.$store.getters.getCurrentTool;

      switch ( tool ) {

        case 'savingsFuture': 
           obj = this.getSavingsForFutureData();
           break;

        case 'investmentFuture':
           obj = this.getInvestmentFutureData();
           break;

        case 'regularWithdrawals':
           obj = this.getRegularWithdrawalsData();
           break;

        case 'systematicWithdrawals':
           obj = this.getSystematicWithdrawalsData();
           break;
      }

      return obj;

    },

    getSavingsForFutureData() {

      var obj = {},
          labels = this.$store.getters.getDropdownLabels();

      obj = {

        title: 'Savings Required for Future',
        detail: labels[this.$store.getters.getToolData('savingsFuture.depositing')] + ' Investment Required:',
        detailHighlight: window.formatCurrency(window.tables.toolSavingsFuture.contribute),
        chart: 'toolSavingsFutureChartPDF',
        inputs: [

          {
            name: 'Sum to Accumulate',
            value: window.formatCurrency(this.$store.getters.getToolData('savingsFuture.sum')),
          },
          {
            name: 'At the rate of',
            value: window.formatPercentage(this.$store.getters.getToolData('savingsFuture.rate')),
          },
          {
            name: 'Number of years',
            value: this.$store.getters.getToolData('savingsFuture.years'),
          },
          {
            name: 'Depositing',
            value: labels[this.$store.getters.getToolData('savingsFuture.depositing')],
          }, 

        ],
        fields: window.tables.legends.toolSavingsFutureChart,
        summary: {
          dataPoints: [
            { 
              field: 'year',
              label: 'Year',
            },
            {
              field: 'contribution',
              label: 'Regular Deposits',
            },
            {
              field: 'total',
              label: 'Total Invested',
            },
            {
              field: 'gain',
              label: 'Gain',
            },
            {
              field: 'value',
              label: 'Value',
            }
          ],
          data: [],
        }        

      };

      var rawData = window.tables.toolSavingsFuture.chartData;

      for ( var x = 0; x < rawData.labels.length; x ++ ) {

        obj.summary.data[x] = {
          year: rawData.labels[x],
          contribution: window.formatCurrency(rawData.contributions.data[x]),
          value: window.formatCurrency(rawData.value.data[x]),
          gain: window.formatCurrency(rawData.otherData.gain[x]),
          total: window.formatCurrency(rawData.otherData.total[x]),
        }

      }

      return obj;

    },

    getInvestmentFutureData() {

      var obj = {},
          labels = this.$store.getters.getDropdownLabels();      

      obj = {

        title: 'Future Value of an Investment',
        detail: 'Future value:',
        detailHighlight: window.formatCurrency(window.tables.toolInvestmentFuture.futureValue),
        chart: 'toolInvestmentFutureDataChartPDF',
        inputs: [

          {
            name: 'Initial investment',
            value: window.formatCurrency(this.$store.getters.getToolData('investmentFuture.sum')),
          },
          {
            name: 'Growth rate',
            value: window.formatPercentage(this.$store.getters.getToolData('investmentFuture.rate')),
          },
          {
            name: 'Number of years',
            value: this.$store.getters.getToolData('investmentFuture.years'),
          },
          {
            name: 'Depositing',
            value: labels[this.$store.getters.getToolData('investmentFuture.depositing')],
          }, 
          {
            name: 'Amount of Deposit',
            value: window.formatCurrency(this.$store.getters.getToolData('investmentFuture.contribution')),
          }, 

        ],

        fields: window.tables.legends.toolInvestmentFutureDataChart,
        summary: {
          dataPoints: [
            { 
              field: 'year',
              label: 'Year',
            },
            {
              field: 'contribute',
              label: 'Regular Deposits',
            },
            {
              field: 'contribution',
              label: 'Total Contribution',
            },
            {
              field: 'gain',
              label: 'Gain',
            },
            {
              field: 'value',
              label: 'Value',
            }
          ],
          data: [],
        }        

      };

      var rawData = window.tables.toolInvestmentFuture.chartData;

      for ( var x = 0; x < rawData.labels.length; x ++ ) {

        obj.summary.data[x] = {
          year: rawData.labels[x],
          contribute: window.formatCurrency(rawData.otherData.contribute[x]),
          contribution: window.formatCurrency(rawData.contributions.data[x]),
          gain: window.formatCurrency(rawData.otherData.gain[x]),
          value: window.formatCurrency(rawData.value.data[x]),
        }

      }

      return obj;

    },

    getRegularWithdrawalsData() {

      var obj = {},
          labels = this.$store.getters.getDropdownLabels();      

      obj = {

        title: 'Regular Withdrawals from an Investment',
        detail: 'Available ' + labels[this.$store.getters.getToolData('regularWithdrawals.withdrawing')] + ' Withdrawal:',
        detailHighlight: window.formatCurrency(window.tables.toolRegularWithdrawals.withdrawal),
        chart: 'toolRegularWithdrawalsChartPDF',
        inputs: [

          {
            name: 'Initial value',
            value: window.formatCurrency(this.$store.getters.getToolData('regularWithdrawals.sum')),
          },
          {
            name: 'At the rate of',
            value: window.formatPercentage(this.$store.getters.getToolData('regularWithdrawals.rate')),
          },
          {
            name: 'Number of years',
            value: this.$store.getters.getToolData('regularWithdrawals.years'),
          },
          {
            name: 'Withdrawing',
            value: labels[this.$store.getters.getToolData('regularWithdrawals.withdrawing')],
          }, 

        ],

        fields: window.tables.legends.toolRegularWithdrawalsChart,      
        summary: {
          dataPoints: [
            { 
              field: 'year',
              label: 'Year',
            },
            {
              field: 'withdrawal',
              label: 'Withdrawal',
            },
            {
              field: 'balance',
              label: 'Balance',
            }
          ],
          data: [],
        }        

      };

      var rawData = window.tables.toolRegularWithdrawals.data;

      for ( var k in rawData ) {

        var x = Number(k);

        obj.summary.data[x] = {
          year: rawData[x].label,
          withdrawal: window.formatCurrency(rawData[x].withdrawal),
          balance: window.formatCurrency(rawData[x].balance),
        }

      }

      return obj;

    },

    getSystematicWithdrawalsData() {

      var obj = {},
          labels = this.$store.getters.getDropdownLabels();      

      obj = {

        title: 'Systematic Withdrawals from an Investment',
        detail: false,
        detailHighlight: false,
        chart: 'toolSystematicWithdrawalsChartPDF',
        inputs: [

          {
            name: 'Initial value',
            value: window.formatCurrency(this.$store.getters.getToolData('systematicWithdrawals.sum')),
          },
          {
            name: 'Withdrawal Amount',
            value: window.formatCurrency(this.$store.getters.getToolData('systematicWithdrawals.withdrawal')),
          },           
          {
            name: 'At the rate of',
            value: window.formatPercentage(this.$store.getters.getToolData('systematicWithdrawals.rate')),
          },
          {
            name: 'Number of years',
            value: this.$store.getters.getToolData('systematicWithdrawals.years'),
          },
          {
            name: 'Withdrawing',
            value: labels[this.$store.getters.getToolData('systematicWithdrawals.withdrawing')],
          }, 

        ],

        fields: window.tables.legends.toolSystematicWithdrawalsChart,      
        summary: {
          dataPoints: [
            { 
              field: 'year',
              label: 'Year',
            },
            {
              field: 'withdrawal',
              label: 'Withdrawal',
            },
            {
              field: 'gain',
              label: 'Gain',
            },            
            {
              field: 'balance',
              label: 'Balance',
            }
          ],
          data: [],
        }        

      };

      var rawData = window.tables.toolSystematicWithdrawals.data;

      for ( var k in rawData ) {

        var x = Number(k);

        obj.summary.data[x] = {
          year: rawData[x].label,
          withdrawal: window.formatCurrency(rawData[x].withdrawal),
          gain: window.formatCurrency(rawData[x].gain),
          balance: window.formatCurrency(rawData[x].balance),
        }

      }

      return obj;

    }        

  },

  props : [

    // Default props
    'icon',

  ],   

}

</script>

<style lang="scss">

  .printForm {

    height: 100%;

    p {

      color: #676767;
      font-style: italic;

    }     

  }

  .printForm__container {

    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;

    height: calc(100% - 8rem);

  }

  .printForm__panel {

    width: calc(50% - .5rem);
    height: calc(100% - 1rem);

    overflow: auto;

    h3 {

      padding-bottom: .75rem;
      margin-bottom: .75rem;
      border-bottom: 1px solid #eee;

    }

    h4 {

      font-size: .9rem;
      margin-top: 1.5rem;
      margin-bottom: .5rem;
      padding-bottom: .5rem;
      color: #555;
      border-bottom: 1px solid #eee;

    }

    .checkbox-wrap {

      margin-bottom: 0;

    }

  }

  .printForm__sections {

    margin-right: 1rem;

  }

  .printForm__subsections {

    padding-left: 1rem;

  }

  .printForm__control {

    width: 100%;

  }

</style>



// WEBPACK FOOTER //
// PrintForm.vue?31a22eb0